import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, ChatAlt2Outline, LightBulbOutline } from '@bonusly/design-system';

import { Page } from '../../config/router';
import { PageLink } from './PageLink';

export const ExternalLinks: FC = () => {
	const { t } = useTranslation('vertical_navbar');

	return (
		<Box
			data-testid="external-links"
			borderBottomWidth={1}
			pt={3}
			pb={1}
			_last={{
				borderBottomColor: 'transparent',
			}}
		>
			<PageLink icon={<LightBulbOutline color="secondary.fg" size="sm" mt={1.5} />} label={t('admin_menu.new_features')} to={Page.NewFeatures} />
			<PageLink icon={<ChatAlt2Outline color="secondary.fg" size="sm" mt={1.5} />} label={t('admin_menu.help_and_support')} to={Page.Help} />
		</Box>
	);
};
